import { createAsyncStore } from "common/axios/asyncModel"
import { NotificationRepository } from "repository/notificationRepository";
import { MESSAGE } from "repository/types/MESSAGE.types";

const notificationList = createAsyncStore();

const getNotificationList = (params: MESSAGE.PostPushHistParams) => {
    notificationList.onGetAll(async () => {return NotificationRepository.onPostPushHist(params);});
}

export const notificationStore = {
    notificationList,
    getNotificationList,
}